import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, Filler } from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  Filler
);

const AreaChart = ({ o, p, m, e, sd, unit }) => {
  const data = {
    labels: ['Pessimistic', 'Optimistic', 'Most Likely', 'Estimated'],
    datasets: [
      {
        label: 'Estimation Values',
        data: [p, o, m, e],
        backgroundColor: 'rgba(75, 192, 192, 0.2)', // Light green
        borderColor: 'rgba(75, 192, 192, 1)', // Dark green
        borderWidth: 1,
        fill: true, // This makes it an area chart
      },
    ],
  };

  const options = {
    scales: {
      x: {
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
      y: {
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: 'white',
        },
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw} days`;
          },
        },
        titleColor: 'white',
        bodyColor: 'white',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
      title: {
        display: true,
        text: 'Estimation Chart in '+unit,
        color: 'white',
      },
    },
  };

  return (
    <div className="w-full h-64">
      <Line data={data} options={options} />
    </div>
  );
};

export default AreaChart;
